import React, { Component, Fragment } from 'react';

import { inject, observer } from 'mobx-react';
import { Alert, Button, Form } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import globalTranslations from '../../../i18n/globalTranslations';
import { createForm } from '../../../models/Form';
import { createFormField } from '../../../models/FormField';
import { isEmail, notBlank } from '../../../util/formValidators';
import FormGroupField from '../../form/FormGroupField';
import { modelOf } from '../../../prop-types';
import ProductStore from '../../../store/ProductStore';

const labels = {
  email: <FormattedMessage {...globalTranslations.emailTitle} />,
  title: <FormattedMessage id="wishlist.EmailTitle" defaultMessage="Title" />,
  message: (
    <FormattedMessage id="wishlist.EmailMessage" defaultMessage="Message" />
  )
};

@observer
export class WishListEmailForm extends Component {
  constructor(props) {
    super(props);
    this.createEmailFrom();
    this.sendEmail = this.sendEmail.bind(this);
    this.getEmailAddress = this.getEmailAddress.bind(this);
    this.getMessageTitle = this.getMessageTitle.bind(this);
    this.getMessageContent = this.getMessageContent.bind(this);
  }

  state = {
    alertVisible: true,
    email: '',
    title: '',
    message: '',
    validForm: false,
    invalidForm: false
  };

  form = null;
  formName = 'ProductListEmailForm';

  createEmailFrom = () => {
    this.form = createForm({
      email: createFormField({}, [isEmail(labels.email)]),
      title: createFormField({}, [notBlank(labels.title)]),
      message: createFormField({}, [])
    });
  };

  sendEmail = (e) => {
    e.preventDefault();
    const { productStore } = this.props;
    productStore
      .sendProductListEmail(this.form.getFieldValues())
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            validForm: true,
            invalidForm: false
          });
        }
      })
      .catch((err) => {
        if (err) {
          this.setState({
            validForm: false,
            invalidForm: true
          });
        }
      });
  };

  getEmailAddress = (e) => {
    let email = e.target.value;
    this.setState({ email });
  };

  getMessageTitle = (e) => {
    let title = e.target.value;
    this.setState({ title });
  };

  getMessageContent = (e) => {
    let message = e.target.value;
    this.setState({ message });
  };

  invalidForm = () => (
    <Alert
      color="danger"
      isOpen={this.state.invalidForm}
      toggle={this.onAlertDismiss}
    >
      <FormattedMessage
        id="wishlist.InvalidForm"
        defaultMessage="Form is invalid. Please check your form."
      />
    </Alert>
  );

  validForm = () => (
    <Alert
      color="success"
      isOpen={this.state.validForm}
      toggle={this.onAlertDismiss}
    >
      <FormattedMessage
        id="wishlist.ValidForm"
        defaultMessage="Email has been sent successfully."
      />
    </Alert>
  );

  onAlertDismiss = () => {
    this.setState({
      alertVisible: false,
      invalidForm: false,
      validForm: false
    });
  };

  formField = (fieldName, props) => {
    const field = this.form.fields.get(fieldName);
    return (
      field.active && (
        <FormGroupField
          field={field}
          formName={this.formName}
          fieldName={fieldName}
          label={labels[fieldName]}
          {...props}
        />
      )
    );
  };

  render() {
    return (
      <Fragment>
        {this.state.validForm ? this.validForm() : ''}
        {this.state.invalidForm ? this.invalidForm() : ''}
        <Form noValidate onSubmit={this.sendEmail}>
          {this.formField('email', {
            type: 'email',
            autoComplete: 'email',
            autoCorrect: 'off',
            autoCapitalize: 'none'
          })}
          {this.formField('title', {
            type: 'text'
          })}
          {this.formField('message', {
            type: 'textarea'
          })}
          <Button className="mb-3" type="submit">
            <FormattedMessage
              id="wishlist.SendList"
              defaultMessage="Send List"
            />
          </Button>
        </Form>
      </Fragment>
    );
  }
}

WishListEmailForm.propTypes = {
  productStore: modelOf(ProductStore).isRequired
};

export default inject('productStore')(WishListEmailForm);
